module.exports = __webpack_public_path__ + "static/opengraph-e890fd8991b6b983ed7a986cee1999c8.png";